var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-taginput',_vm._b({attrs:{"autocomplete":"","loading":_vm.isLoading,"data":_vm.items,"field":"user.full_name"},on:{"typing":_vm.debouncedSearch,"input":_vm.onInput},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'b-taginput',_vm.$attrs,false))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a186f3d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/UserListInput.vue
// module id = jmdi
// module chunks = 1